import { render, staticRenderFns } from "./ActiveRecord.vue?vue&type=template&id=0b5a0be0&"
import script from "./ActiveRecord.vue?vue&type=script&lang=js&"
export * from "./ActiveRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports